import styled, { css } from "styled-components";
import Spring from "../Spring";

export const StyledFotter = styled.footer`
    background-color: ${p => p.theme.mode === "dark" ? p.theme.c.cardBackground : p.theme.c.grey7};
    box-shadow: 0 0 4px 0 ${p => p.theme.c.blackShadow2};
    color: white;
    text-align: right;
    ${p =>
        p.theme.withNotch(css`
            padding-bottom: calc(env(safe-area-inset-bottom) / 2);
        `)}
`;

export const FooterItem = styled.div`
    display: inline-block;
    margin-right: 16px;
`;

export const FooterSpring = styled(Spring)`
    padding: 12px;
    margin: auto;
    display: block;
    text-align: center;
`;

export const FixedBottomBlock = styled.div`
    height: 56px;
    ${p =>
        p.theme.sm.min(css`
            display: none;
        `)}
`;
